import { adt, iots } from '@code-expert/prelude';

export const ExerciseVisibility = iots.keyof({ no: null, auto: null, yes: null });

export const foldExerciseVisibility = adt.foldFromKeys(ExerciseVisibility.keys);

export type ExerciseVisibility = iots.TypeOf<typeof ExerciseVisibility>;
